import Component from "@tunnel-components/@pages/supervision/camera/statistics/component";
import * as React from "react";
import { connect } from "react-redux";
import { StatsByCameraLoadedActionCreator } from "@tunnel-store/index";
import * as Lodash from "lodash";
import * as i18next from "i18next"; // traduction

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * ......
     */
    this.state = {
      onglet: [
        i18next.t("nombre totale d'alarmes"),
        i18next.t("nombre faux positifs"),
        i18next.t("nombre d'incidents averes"),
      ],
      ongletSelect: [],
      paramIdentifiant: props.match.params.id,
      period: 24, // 24,
      periodArray: [i18next.t("7 derniers jours"), i18next.t("aujourdhui")],
      periodOpen: false,
      periodText: i18next.t("aujourdhui"),
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onOngletSelect = this.onOngletSelect.bind(this);
    this.onPeriodOpen = this.onPeriodOpen.bind(this);
    this.onSelectToggle = this.onSelectToggle.bind(this);
  }
  /**
   * @method
   * @name onSelectToggle
   * @param { any } event
   * @param { any } elem
   * @param { number } param
   * @infos "https://reactjs.org"
   */
  public onSelectToggle = (param: string, elem: number) => (
    event: any
  ): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ periodOpen: !this.state.periodOpen });
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ periodText: param });
    if (elem === 1) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState({ period: 24 });
    } else {
      {
        /** Empêcher la mutation du state  7 */
      }
      this.setState({ period: 7 });
    }
  };
  /**
   * @method
   * @name onPeriodOpen
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onPeriodOpen = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ periodOpen: !this.state.periodOpen });
  };
  /**
   * @method
   * @name onOngletSelect
   * @param { any } event
   * @param { number } param
   * @infos "https://reactjs.org"
   */
  public onOngletSelect = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @description :
     * @name  ongletSelect
     * @types boolean[]
     */
    const ongletSelect: boolean[] = [];

    for (let i = 0; i < Math.ceil(this.state.onglet.length); i++) {
      ongletSelect.push(false);
    }

    ongletSelect[param] = true;

    {
      /** Empêcher la mutation du state */
    }
    this.setState({ ongletSelect });
    {
      /** stockage locale de l'état des onglets */
    }
    localStorage.setItem("ongletSelect", JSON.stringify(ongletSelect));
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ loading: true });
    {
      /** dispatch actions  */
    }
    /**
     * @constant
     * @name currentongletSelect
     * @type any
     */
    const currentongletSelect: any = localStorage.getItem("ongletSelect");
    /**
     * @constant
     * @description :
     * @name  ongletSelect
     * @types boolean[]
     */
    const ongletSelect: boolean[] = [];
    {
      /** comparaison */
    }
    if (currentongletSelect !== null) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState({ ongletSelect: JSON.parse(currentongletSelect) });
    } else {
      {
        /** boucle */
      }
      for (let i = 0; i < Math.ceil(this.state.onglet.length); i++) {
        ongletSelect.push(false);
      }
      ongletSelect[0] = true;
      {
        /** Empêcher la mutation du state */
      }
      this.setState({ ongletSelect });
    }

    this.props
      .StatsByCameraLoadedActionCreator(
        this.state.paramIdentifiant,
        this.state.period
      )
      .then(() => this.setState({ loading: false }));
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ stats: false });
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    if (prevState.period !== this.state.period) {
      this.setState({ loading: true });
      this.props
        .StatsByCameraLoadedActionCreator(
          this.state.paramIdentifiant,
          this.state.period
        )
        .then(() => this.setState({ loading: false }));
    }
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    if (nextProps.error !== this.props.error) {
      if (!Lodash.isUndefined(nextProps.error)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState({ errorserver: true });
      }
    } else if (nextProps.dataStats !== this.props.dataStats) {
      const label: any[] = [];
      const dataYForAllAlerte: any[] = [];
      const dataYForTrueAlerte: any[] = [];
      const dataYForFalseAlerte: any[] = [];

      if (!Lodash.isUndefined(nextProps.dataStats)) {
        for (let i = 0; i < Math.ceil(nextProps.dataStats.length); i++) {
          label.push(nextProps.dataStats[i].colX);

          dataYForAllAlerte.push(nextProps.dataStats[i].colYAll);

          dataYForTrueAlerte.push(nextProps.dataStats[i].colYTrue);

          dataYForFalseAlerte.push(nextProps.dataStats[i].colYFalse);
        }
        {
          /** mutation  du state */
        }
        this.setState({
          dataYForAllAlerte,
          dataYForFalseAlerte,
          dataYForTrueAlerte,
          label,
        });
      }
    }
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        {...this.state}
        {...this.props}
        onOngletSelect={this.onOngletSelect}
        onPeriodOpen={this.onPeriodOpen}
        onSelectToggle={this.onSelectToggle}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    dataStats: state.StatsByCameraLoaded.data,
    error: state.StatsByCameraLoaded.error,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, { StatsByCameraLoadedActionCreator })(
  Container
);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/statistics/container.tsx